// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__36xEm","upload":"Small_upload__qGuJN","imageWrap":"Small_imageWrap__3vmed","removeBtn":"Small_removeBtn__1ebjo"};